import { useRouteLoaderData,json, redirect} from "react-router-dom";
import EventItem from '../components/EventItem';
const EventDetailPage = () =>{
    const data=useRouteLoaderData('event-detail');
    return (
        <EventItem event={data.event}/>
    );
};

export default EventDetailPage;

export async function loader({request,params}){
    const id=params.eventId;
    const response=await fetch('https://newsletter-app-9e353b94f1d7.herokuapp.com/events/'+id);
    if(!response.ok){
        throw json({message:'Error!!'},{status:500});
    }else{
        return response;
    }
    
};

export async function action({params,request}){
    const id=params.eventId;
    const response=await fetch('https://newsletter-app-9e353b94f1d7.herokuapp.com/events'+id,{
        method:request.method,
    });
    if(!response.ok){
        throw json({message:'Could not delete'},{status:500});
    }
    return redirect('/events');
}